import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { CircularProgress, Fade, TextField } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { validatePromoCode } from '../../utils/validators/validateForm';
import { NotificationManager } from 'react-notifications';
import { FormattedMessage, injectIntl } from 'react-intl';

class AddPromoPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaderButton: false,
            closeVerification: false,
            code: '',
            codeError: ''
        };
    }
    renderButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <Button
                    variant="contained"
                    style={{
                        backgroundColor: this.props.theme.palette.primary.main,
                        color: '#ffffff',
                        fontSize: '16px'
                    }}
                    size="large"
                    onClick={() => this.applyPromoCode()}
                >
                    <FormattedMessage id="promo.apply" defaultMessage="Apply" />
                </Button>
            );
        }
    };
    handleClose = () => {
        this.props.closePopup();
    };
    applyPromoCode = () => {
        if (validatePromoCode(this.state.code, this.handleError)) {
            this.setState({ loaderButton: true });
            this.props.checkPromoCodeAction(
                {
                    promoCode: this.state.code,
                    packageSelected: []
                },
                this.onDone
            );
        }
    };

    onDone = (success, data) => {
        if (success) {
            this.setState({ loaderButton: false });
            NotificationManager.success(data.message, 'Success');
            this.handleClose();
        } else {
            this.setState({ loaderButton: false });
            NotificationManager.error(data.message, 'Error');
            // this.handleClose();
        }
    };
    changeCodeText = event => {
        this.setState({
            code: event.target.value,
            codeError: ''
        });
    };

    handleError = params => {
        this.setState(params);
    };
    onSlotPress = slot => () => {
        this.props.onTimeSlotSelected(slot);
    };

    render() {
        const { codeError } = this.state;
        const { formatMessage } = this.props.intl;
        return (
            <div>
                <Dialog
                    fullWidth={true}
                    maxWidth={'xs'}
                    TransitionComponent={Fade}
                    className="service-modal modal-h-auto"
                    open={this.props.isVisible}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <div
                        className="modal-header dir-pop-head"
                        style={{
                            backgroundColor: this.props.theme.palette.primary
                                .main
                        }}
                    >
                        <h4>
                            <FormattedMessage
                                id="promo.addcoupon"
                                defaultMessage="Add Coupon"
                            />
                        </h4>
                    </div>
                    <div className="modal-body dir-pop-body">
                        <DialogContent className="service-from-body">
                            <div className="col-md-12 cpn-pag-form mt-0">
                                <div className="row">
                                    <form className="form-new mt-0">
                                        <TextField
                                            error={codeError ? true : false}
                                            helperText={codeError}
                                            id="coupon-code"
                                            label={formatMessage({
                                                id: 'promo.addcoupon'
                                            })}
                                            placeholder={formatMessage({
                                                id: 'promo.yourcoupon'
                                            })}
                                            fullWidth
                                            className="login-form-textfield"
                                            margin="normal"
                                            name={this.state.code}
                                            onChange={this.changeCodeText}
                                            title="Enter the promocode"
                                        />
                                    </form>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <div className="col-md-12">
                                {this.renderButton()}
                            </div>
                        </DialogActions>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const composedHOC = compose(
    withTheme(),

    connect(
        null,
        actions
    )
);
export default composedHOC(injectIntl(AddPromoPopup));



// WEBPACK FOOTER //
// ./src/components/Booking/AddPromoPopup.jsx